export default __webpack_public_path__ + "static/media/334.55f0fdc3.png";